import { useEffect, useState } from 'react';
import { Box, Button, Pagination, Typography } from '@mui/material';
import { MAX_RESULT_PER_PAGE } from '../shared/AppConstants';
import { SortByDropdown } from './search/SortByDropdown';

export default function StrategyWithSortandPagination(props) {
  const { list, onDownloadSearchResults } = props;
  const [page, setPage] = useState(1);
  const [numberOfStrategies, setNumberOfStrategies] = useState(list.length);
  const [selectedSortOption, setSelectedSortOption] = useState('MGC A-Z');
  const [listToShow, setListToShow] = useState(list);
  const perPage = MAX_RESULT_PER_PAGE;
  const noOfPages = Math.ceil(list.length / perPage);

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    setNumberOfStrategies(list.length);
    setPage(1);
  }, [list]);

  useEffect(() => {
    const sortedArray = [...list];

    if (selectedSortOption === 'MGC A-Z') {
      sortedArray.sort(function (x, y) {
        return x.props.strategy.decorated.mgcs[0].localeCompare(
          y.props.strategy.decorated.mgcs[0]
        );
      });
    } else if (selectedSortOption === 'MGC Z-A') {
      sortedArray.sort(function (x, y) {
        return y.props.strategy.decorated.mgcs[0].localeCompare(
          x.props.strategy.decorated.mgcs[0]
        );
      });
    }
    setListToShow(sortedArray);
    setPage(1); // Resetting page to 1
  }, [selectedSortOption, list]);

  function currentPageResultsStart() {
    return (page - 1) * perPage + 1;
  }

  function currentPageResultsEnd() {
    const start = currentPageResultsStart();
    const end = start + perPage - 1;

    return end < numberOfStrategies ? end : numberOfStrategies;
  }

  return (
    <Box>
      {numberOfStrategies > 0 && (
        <Box
          sx={(theme) => ({
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: theme.fuel6Tokens.JddcSpacingMedium
          })}
        >
          <Typography variant="bodySmall">
            {currentPageResultsStart()} - {currentPageResultsEnd()} of{' '}
            {numberOfStrategies} Results
          </Typography>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '0.5rem'
            }}
          >
            <Button
              variant="tertiary"
              startIcon={<fuel-icon name="download" />}
              onClick={onDownloadSearchResults}
            >
              Download Search Results
            </Button>
            <SortByDropdown
              selectedSortOption={selectedSortOption}
              setSelectedSortOption={setSelectedSortOption}
            />
          </Box>
        </Box>
      )}

      <>
        {listToShow.slice((page - 1) * perPage, (page - 1) * perPage + perPage)}
      </>

      {numberOfStrategies > MAX_RESULT_PER_PAGE && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            mt: 2
          }}
        >
          <Pagination
            count={noOfPages}
            page={page}
            onChange={handlePageChange}
          />
        </Box>
      )}
    </Box>
  );
}
